module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1267.13231c0f.png";